import {setCity} from './api.js'

/**
 *
 * @param {HTMLElement} element
 */
export function bindEvents(element) {
    element.removeAttribute('is');
    element.addEventListener('click', onClick);
}

/**
 *
 * @param {Event} event
 */
function onClick({currentTarget}) {
    const {
        apiSet: setURL,
        code: CODE,
        cityName: CITY_NAME,
        callback: callbackName,
    } = currentTarget.dataset;
    const callback = window[callbackName];
    const data = {CODE, CITY_NAME};

    setCity(setURL, data, callback);
}